import React from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../context/AuthContext";
import ReportForm from "../components/forms/ReportForm";
import Button from "../components/ui/Button";
import LanguageSwitcher from "../components/ui/LanguageSwitcher";

const ReportGenerationPage: React.FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const authContext = useContext(AuthContext);

	if (!authContext) {
		throw new Error("ReportGenerationPage must be used within AuthProvider");
	}

	const { logout } = authContext;

	const handleLogout = async () => {
		try {
			await logout();
			navigate("/login");
		} catch (error) {
			console.error("Logout failed:", error);
		}
	};

	const handleReportSuccess = () => {
		// Optionally navigate to reports overview after successful generation
	};

	return (
		<div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-50 to-primary-50">
			<header className="bg-white/90 backdrop-blur-sm shadow-soft border-b border-gray-200/50 sticky top-0 z-10">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-5 gap-4">
						<h1 className="text-3xl font-bold text-gradient">
							{t("report.title")}
						</h1>
						<div className="flex items-center gap-2 sm:gap-4 w-full sm:w-auto">
							<LanguageSwitcher />
							<Button
								type="button"
								variant="secondary"
								size="sm"
								onClick={() => navigate("/reports")}
								fullWidth={false}
								className="flex-1 sm:flex-none"
							>
								{t("report.viewReports")}
							</Button>
							<Button
								type="button"
								variant="secondary"
								size="sm"
								onClick={handleLogout}
								fullWidth={false}
								className="flex-1 sm:flex-none"
							>
								{t("report.logout")}
							</Button>
						</div>
					</div>
				</div>
			</header>

			<main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
				<div className="bg-white shadow-soft-lg rounded-2xl p-6 md:p-10 border border-gray-100">
					<ReportForm onSuccess={handleReportSuccess} />
				</div>
			</main>
		</div>
	);
};

export default ReportGenerationPage;
